import { Link, useParams } from 'react-router-dom'

import { FiChevronLeft } from 'react-icons/fi'

export default function Breadcrumb () {
  const params = useParams()
  // const path = useLocation()
  // console.log(path)
  return (
    <>
      <div className='searchTypeRow'>
        <div className='breadcrumb'>
          <Link to={'/type'}>عناوین</Link>

          <span className='spacer'>
            <FiChevronLeft />
          </span>

          {params.typeId && (
            <Link to={`/type/${params.typeId}`}>{params.typeId}</Link>
          )}

          <span className='spacer'>
            <FiChevronLeft />
          </span>

          <span className='current'>{params.contentId}</span>
        </div>
      </div>
    </>
  )
}
